import {
  GET_CVC_LVL_1,
  GET_CVC_LVL_2,
  GET_CVC_LVL_3,
  GET_CVC_LVL_4,
  GET_CVC_LVL_5,
} from 'redux/actions/cvc';

const initialState = {
  level_1: [],
  level_2: [],
  level_3: [],
  level_4: [],
  level_5: [],
};
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_CVC_LVL_1: {
      if (payload.level === '1') {
        return {
          ...state,
          level_1: payload.data,
          link: '/business-process/cvc/',
        };
      }
      if (payload.level === '2') {
        return {
          ...state,
          level_2: payload.data,
          link_2: `/business-process/cvc/lvl-2/${payload.idx}`,
        };
      }
      if (payload.level === '3') {
        return {
          ...state,
          level_3: payload.data,
          link_3: `/business-process/cvc/lvl-3/${payload.idx}`,
        };
      }
      if (payload.level === '4') {
        return {
          ...state,
          level_4: payload.data,
          link_4: `/business-process/cvc/lvl-4/${payload.idx}`,
        };
      }
      if (payload.level === '5') {
        return {
          ...state,
          level_5: payload.data,
          link_5: `/business-process/cvc/lvl-5/${payload.idx}`,
        };
      }
      if (payload.level === '6') {
        return {
          ...state,
          level_6: payload.data,
          link_6: `/business-process/cvc/lvl-6/${payload.idx}`,
        };
      }
      if (payload.level === '7') {
        return {
          ...state,
          level_7: payload.data,
          link_7: `/business-process/cvc/lvl-7/${payload.idx}`,
        };
      }
    }

    default:
      return state;
  }
};
